import { AdminAndClientAccessRoutes } from './client_routes';
import { AdminRestrictedRoutes } from './admin_client_routes';
import { Box } from '@mui/material';
import CalendarPage from '../pages/calendar';
import CallbackPage from '../pages/callback';
import ClientPage from '../pages/client_dashboard';
import CompanyManagementPage from '../pages/company_management';
import DashboardPage from '../pages/dashboard';
import DealsPage from '../pages/deals';
import IntegrationPage from '../pages/integrations';
import LeadManagementPage from '../pages/lead_management';
import NotificationsPage from '../pages/notification';
import { protectedRoute } from './';
import RoloDexPage from '../pages/rolodex';
import SubscriptionCallbackPage from '../pages/billing/callback';
import SubscriptionPage from '../pages/billing/subscription';
import UserProfilePage from '../pages/profile';

export const AdminRoutes = [
    {
        path: 'subscription',
        Component: () => protectedRoute(<SubscriptionPage />, ['organizationOwner'])
    },
    {
        path: 'dashboard',
        Component: () => protectedRoute(<DashboardPage />, ['companyManager', 'organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'deals',
        Component: () => protectedRoute(<DealsPage />, ['organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'leads',
        Component: () => protectedRoute(<LeadManagementPage />, ['organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'rolodex',
        Component: () => protectedRoute(<RoloDexPage />, ['organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'integrations',
        Component: () => protectedRoute(<IntegrationPage />, ['client', 'companyManager', 'organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'profile',
        Component: () => protectedRoute(<UserProfilePage />, ['client', 'companyManager', 'organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'company-management',
        Component: () => protectedRoute(<CompanyManagementPage />, ['organizationOwner', 'organizationAdmin'])
    },
    {
        path: 'subscription-callback',
        Component: () => protectedRoute(<SubscriptionCallbackPage />, ['organizationOwner'])
    },
    {
        path: 'callback',
        Component: () => protectedRoute(<CallbackPage />, ['client', 'companyManager', 'organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'calendar',
        Component: () => protectedRoute(<Box p={2}><CalendarPage /></Box>, ['companyManager', 'organizationOwner', 'organizationAdmin'])
    },
    {
        path: 'notification',
        Component: () => protectedRoute(<NotificationsPage />, ['client', 'companyManager', 'organizationOwner', 'organizationAdmin', 'salesManager', 'salesMember'])
    },
    {
        path: 'client/:id',
        Component: ClientPage,
        children: [
            ...AdminAndClientAccessRoutes,
            ...AdminRestrictedRoutes
        ]
    }
];